import React from 'react'
import { IChildUserConfig } from '../../../../utility/types'
import { IRenderControl, Card, RenderControl, Flex, Button } from '@fareye/ui'
import { cancelToken, get, flatten, isEmpty } from '@fareye/utils'
import { Header } from '../../components/Header'
import { FilterForm } from './FilterForm'
import { IState } from '@fareye/types'
import { HEADER_INFLECTION } from '../../../../config/constants'
import { DataListing } from '../../components/DataListing'

export function FilterListing({ config, id, label }: IChildUserConfig) {
  const [apiData, setApiData] = React.useState<IRenderControl>({
    data: [],
    message: '',
    isError: false,
    isLoading: false,
    isSuccess: true
  })
  const [selectedDataForEdit, setSelectedDataForEdit] = React.useState<any>({})
  const source = cancelToken().source()
  const crudSource = cancelToken().source()
  const { apiConfig, selectedColumns } = config.children['listFilter']
  const { apiUrl } = apiConfig['listFilter']
  const [mapperData, setMapperData] = React.useState<IState<string> | Object>(
    {}
  )
  const containerRef = React.useRef(null)
  const { apiConfig: crudConfig } = !isEmpty(selectedDataForEdit)
    ? config.children['editFilter']
    : config.children['addFilter']

  //NOTE: Fetching Child Users
  React.useEffect(() => {
    fetchData()
    return () => crudSource.cancel('Unmount Filter Listing Comp')
  }, [])

  function resetEditForm() {
    setSelectedDataForEdit(null)
  }

  async function fetchData() {
    try {
      setApiData({ ...apiData, isLoading: true })
      const { data } = await get(apiUrl, source.token)
      let filterData = Object.entries(data.filters).map(([key, value]: any) => {
        return value.map((ele: any) => {
          ele.type = key
          return ele
        })
      })
      filterData = flatten(filterData)
      setMapperData(data.map_models)
      setApiData({ ...apiData, isLoading: false, data: filterData })
    } catch (ex:any) {
      setApiData({
        ...apiData,
        isLoading: false,
        isError: true,
        message: 'Something went wrong...'
      })
      console.warn('ChildUserListing', ex)
    }
  }

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 10,
        overflow: 'auto'
      }}
    >
      <Flex style={{ marginBottom: 10 }} column bg="#fff">
        {!isEmpty(selectedDataForEdit) && (
          <Flex m={2} justifyContentFlexEnd>
            <Button
              mr={10}
              variant="primary m"
              onClick={() => {
                resetEditForm()
              }}
            >
              Add New Filter
            </Button>
          </Flex>
        )}
        <FilterForm
          apiConfig={crudConfig}
          selectedDataForEdit={selectedDataForEdit}
          mapperData={mapperData}
          fetchData={fetchData}
        />
      </Flex>

      <DataListing
        apiData={apiData}
        label={label}
        containerRef={containerRef}
        selectedColumns={selectedColumns ? selectedColumns : []}
        setSelectedDataForEdit={setSelectedDataForEdit}
      />
    </div>
  )
}
